import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isPristine } from 'redux-form';
import _ from 'lodash';
import {
  displayWrapper,
  forceFormRefresh,
  goToHome,
  goToNextSpecimen,
  refreshSeadragon,
  saveAnalysis,
  storeUnsavedAnalysis,
  removeStoredUnsavedAnalysis,
} from '../redux/actions';
import { userRoles } from '../constants';
import CaseAndSpecimenAnalysisForm from '../forms/caseAndSpecimenAnalysisForm/CaseAndSpecimenAnalysisForm';
import { buildSpecimenFormId } from '../helpers/formIdCreator';

class SpecimenFormContainer extends Component {

  state = {
    initialValues: {},
  }

  static getDerivedStateFromProps(props, state) {
    const { latestSavedValues, unsavedValues, pristine } = props;
    if (pristine && !_.isEmpty(state.initialValues)) {
      return null;
    }
    let initialValuesToBe;

    if (unsavedValues) {
      // SOURCE PRIORITY 1
      initialValuesToBe = Object.assign({}, unsavedValues);
    } else if (latestSavedValues) {
      // SOURCE PRIORITY 2
      initialValuesToBe = Object.assign({}, latestSavedValues);
    }

    if (initialValuesToBe) {
      const stateIsInSync = JSON.stringify(state.initialValues) === JSON.stringify(initialValuesToBe);
      if (!stateIsInSync) {
        return { initialValues: initialValuesToBe };
      }
    }

    return null;
  }


  componentDidUpdate() {
    const {
      pristine,
      currentFormValues,
      formId,
      removeStoredUnsavedAnalysis,
      latestSavedValues,
    } = this.props;
    if (!pristine && currentFormValues && latestSavedValues) {
      const currentIsInSyncWithLatestSaved = JSON.stringify(latestSavedValues) === JSON.stringify(currentFormValues);
      if (currentIsInSyncWithLatestSaved) {
        removeStoredUnsavedAnalysis(formId);
      }
    }
  }

  componentWillUnmount() {
    const {
      pristine,
      currentFormValues,
      formId,
      storeUnsavedAnalysis,
      latestSavedValues,
    } = this.props;
    if (!pristine && currentFormValues) {
      if (latestSavedValues) {
        const currentIsInSyncWithLatestSaved = JSON.stringify(latestSavedValues) === JSON.stringify(currentFormValues);
        if (!currentIsInSyncWithLatestSaved) {
          storeUnsavedAnalysis(currentFormValues, formId);
        }
      } else {
        storeUnsavedAnalysis(currentFormValues, formId);
      }
    }
  }


  handleFormSubmit = () => {
    const specimen = this.props.selectedSpecimen;
    
    //const formIsValid = validateSpecimenAnalysisValues(this.props.currentFormValues);
   // this.props.setSpecimenAnalysisIsValid(specimen._id, this.props.currentPathologist._id, formIsValid)
    
    specimen.partTwoSpecimenLevelForm = this.props.currentFormValues;
    this.props.saveAnalysis(
      specimen.partTwoSpecimenLevelForm,
      this.props.currentPathologist,
      specimen._id,
      this.props.selectedSpecimen.validationComplete,
      this.props.user.role === userRoles.val_pathologist,
      false,
      this.props.formId
    );

  };

  /*   handleMarkAsDone = (isDone, isReopen) => {
      const specimen = this.props.selectedSpecimen;
      specimen.partTwoSpecimenLevelForm = this.props.currentFormValues;
      const isValidation = true;
      this.props.saveAnalysis(
        specimen.partTwoSpecimenLevelForm,
        this.props.currentPathologist,
        specimen._id,
        isDone,
        isValidation,
        isReopen,
        this.props.formId
      ).then(saveSuccess => {
        if (saveSuccess) {
          this.props.forceFormRefresh();
          if (isDone) {
            this.props.goToHome();
          }
        }
      });
    };
  
    handleSaveAndGoToNext = () => {
      const specimen = this.props.selectedSpecimen;
      specimen.partTwoSpecimenLevelForm = this.props.currentFormValues;
      this.props.saveAnalysis(
        specimen.partTwoSpecimenLevelForm,
        this.props.currentPathologist,
        specimen._id,
        true,
        true,
        false,
        this.props.formId
      ).then(saveSuccess => {
        if (saveSuccess) {
          this.props.goToNextSpecimen();
          this.props.refreshSeadragon();
  
          this.props.forceFormRefresh();
          this.props.displayWrapper();
  
          setTimeout(() => {
            this.props.displayWrapper();
          }, 100);
        }
      });
    }; */


  render() {

    return (

      <CaseAndSpecimenAnalysisForm
        formSubmit={this.handleFormSubmit}
        handleMarkAsDone={this.handleMarkAsDone}
        handleSaveAndGoToNext={this.handleSaveAndGoToNext}
        form={this.props.formId}
        initValues={this.state.initialValues}
      />

    );
  }
}

const mapStateToProps = (state) => {
  const { form } = state;
  const { _case } = state;
  const { snapshots, selectedSnapshot, showSnapshot } = state.snapshot;
  const { user } = state.auth;
  const { currentPathologist, showForm, selectedSpecimen } = state._case;
  const { unsavedAnalyzes } = _case;
  const formId = buildSpecimenFormId(selectedSpecimen, currentPathologist);
  const pristine = isPristine(formId)(state);
  const currentFormValues = form[formId] !== undefined ? form[formId].values : null;
  const unsavedAnalysis = unsavedAnalyzes.find(analysis => analysis.formId === formId);
  const unsavedValues = unsavedAnalysis !== undefined ? unsavedAnalysis.values : null;

  let latestSavedValues;

  try {
    latestSavedValues = selectedSpecimen
      .analyses
      .find(a => a.assignee === currentPathologist._id)
      .analysis
      .partTwoSpecimenLevelForm;
  } catch (e) {
    latestSavedValues = null;
  }



  return {
    user,
    form,
    _case,
    currentPathologist,
    snapshots,
    selectedSnapshot,
    showSnapshot,
    showForm,
    selectedSpecimen,
    formId,
    pristine,
    currentFormValues,
    latestSavedValues,
    unsavedValues,

  };
};

export default connect(
  mapStateToProps,
  {
    saveAnalysis,
    goToNextSpecimen,
    refreshSeadragon,
    displayWrapper,
    forceFormRefresh,
    goToHome,
    storeUnsavedAnalysis,
    removeStoredUnsavedAnalysis,
  },
)(SpecimenFormContainer);
